/* eslint-disable */
function fptiSetup(custId, page, tmpl, pgrp, item, link, srch, schnor, imrk) {
  if (typeof window === 'undefined' || !(window && window.PAYPAL)) {
    return;
  }

  if (fpti && PAYPAL.analytics) {
    fpti.page = page;
    fpti.pgrp = pgrp || page;
    fpti.tmpl = tmpl;
    fpti.cust = custId || '';
    fpti.pgtf = 'Nodejs';
    fpti.item = item || '';
    fpti.link = link || '';
    fpti.srch = srch || '';
    fpti.schnor = schnor || '';
    fpti.imrk = imrk || '';
    fpti.comp = 'merchanthubnodeweb';
  }
}

function recordImpression(
  custId,
  page,
  tmpl,
  pgrp,
  item,
  link,
  srch,
  schnor,
  imrk
) {
  fptiSetup(custId, page, tmpl, pgrp, item, link, srch, schnor, imrk);

  if (
    PAYPAL.analytics &&
    PAYPAL.analytics.instance &&
    PAYPAL.analytics.instance.recordImpression
  ) {
    PAYPAL.analytics.instance.recordImpression();
  }

  if (typeof PAYPAL.analytics !== 'undefined' && !PAYPAL.analytics.instance) {
    PAYPAL.pta = PAYPAL.analytics.setup();
  }
}

function recordClick(custId, page, tmpl, pgrp, item, link, srch, schnor, imrk) {
  fptiSetup(custId, page, tmpl, pgrp, item, link, srch, schnor, imrk);

  if (
    PAYPAL.analytics &&
    PAYPAL.analytics.instance &&
    PAYPAL.analytics.instance.recordClick
  ) {
    PAYPAL.analytics.instance.recordClick();
  }

  if (typeof PAYPAL.analytics !== 'undefined' && !PAYPAL.analytics.instance) {
    PAYPAL.pta = PAYPAL.analytics.setup();
  }
}
export default { recordImpression, recordClick };
export { recordImpression, recordClick };
